module.exports = __webpack_public_path__ + "media/18.1ff1bb29.mp3";